import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useApp } from '../context/AppContext';

const Footer = () => {
    const { siteContent, adminUser, memberUser } = useApp();
    const { contact } = siteContent;

    return (
        <footer className="bg-gray-900 text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                    {/* Company Info */}
                    <div className="space-y-4">
                        <h3 className="text-2xl font-bold bg-gradient-to-r from-primary-500 to-primary-400 bg-clip-text text-transparent">
                            POWER CLEAN
                        </h3>
                        <p className="text-gray-400 leading-relaxed">
                            India's premier MLM network for high-quality cleaning products. Empowering individuals to build sustainable businesses.
                        </p>
                        <div className="flex space-x-4 pt-4">
                            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                                <Facebook className="w-5 h-5" />
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                                <Instagram className="w-5 h-5" />
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary-600 transition-colors">
                                <Twitter className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-gray-100">Quick Links</h4>
                        <ul className="space-y-3">
                            <li><Link to="/about" className="text-gray-400 hover:text-primary-500 transition-colors">About Us</Link></li>
                            <li><Link to="/products" className="text-gray-400 hover:text-primary-500 transition-colors">Our Products</Link></li>
                            <li><Link to="/income-plan" className="text-gray-400 hover:text-primary-500 transition-colors">Business Plan</Link></li>
                            <li><Link to="/contact" className="text-gray-400 hover:text-primary-500 transition-colors">Contact Support</Link></li>
                            <li><Link to="/admin" className="text-gray-500 hover:text-primary-500 transition-colors text-sm">Admin Login</Link></li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-gray-100">Legal</h4>
                        <ul className="space-y-3">
                            <li><Link to="/privacy" className="text-gray-400 hover:text-primary-500 transition-colors">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="text-gray-400 hover:text-primary-500 transition-colors">Terms & Conditions</Link></li>
                            <li><Link to="/refund" className="text-gray-400 hover:text-primary-500 transition-colors">Refund Policy</Link></li>
                            <li><Link to="/disclaimer" className="text-gray-400 hover:text-primary-500 transition-colors">Income Disclaimer</Link></li>
                            <li><Link to="/legal-certificates" className="text-gray-400 hover:text-primary-500 transition-colors">Legal Certificates</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-gray-100">Get in Touch</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <MapPin className="w-5 h-5 text-primary-500 mr-3 mt-1" />
                                <span className="text-gray-400">{contact.address}</span>
                            </li>
                            <li className="flex items-center">
                                <Phone className="w-5 h-5 text-primary-500 mr-3" />
                                <span className="text-gray-400">{contact.phone}</span>
                            </li>
                            <li className="flex items-center">
                                <Mail className="w-5 h-5 text-primary-500 mr-3" />
                                <span className="text-gray-400">{contact.email}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 text-center">
                    <p className="text-gray-500">
                        &copy; {new Date().getFullYear()} Power Clean India. All rights reserved.
                    </p>
                    <p className="text-[10px] text-gray-700 mt-2 font-mono">
                        System v1.2 | Admin: {adminUser?.id || 'None'} | Member: {memberUser?.id || 'None'}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
